import {ChangeDetectionStrategy, Component, InputSignal, input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormInputComponent} from '../../../../shared/elements/form-input/form-input.component';
import {TranslatePipe} from '../../../../shared/pipes/translate.pipe';
import {FeedbackStructureQuestionFormQuestion} from '../../feedback-structure-create-update-dialog/feedback-structure-question/feedback-structure-question-form.model';
import {feedbackAnswerControlName} from '../../helpers/feedback-structure-preview-control-names';

@Component({
	selector: 'app-feedback-form-element-text-input',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [FormInputComponent, TranslatePipe],
	template: `
		<div class="ps-md-3">
			<app-form-input
				[fG]="formGroup()"
				[fCN]="answerControlName()"
				[placeholder]="'FEEDBACKQUESTIONTYPETEXTINPUT' | translate"
				[errorText]="'INPUTREQUIRED' | translate"
				[disabled]="disabled()"
			></app-form-input>
		</div>
	`,
})
export class FeedbackFormElementTextInputComponent {
	public question: InputSignal<FeedbackStructureQuestionFormQuestion> = input.required();
	public formGroup: InputSignal<FormGroup> = input.required();
	public controlNamePrefix: InputSignal<string> = input('preview');
	public disabled: InputSignal<boolean> = input(false);

	public answerControlName(): string {
		return feedbackAnswerControlName(this.question(), this.controlNamePrefix());
	}
}
